import { actions, types } from './requests'
export const GETBADGESCANLIST_TYPES = {
    ...types('GETBADGESCANLIST'),
}
export const GETBADGESCANLIST_ACTIONS = {
    ...actions('GETBADGESCANLIST'),
}